<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top> {{ text }}
            <v-btn color="pink" text @click="msg = false"> Close</v-btn>
        </v-snackbar>
        <v-card>
            <v-layout row wrap class="pa-2 ma-2 hideOnPrint">
                <v-flex xs12>
                    <v-btn fab x-small @click="$router.go(-1)">
                        <v-icon>navigate_before</v-icon>

                    </v-btn>
                </v-flex>

                <v-flex xs12 md1 class="mb-2">
                    <v-btn
                        fab
                        small
                        @click="printTable()"
                        class="ml-8 white--text"
                        color="#2b6993"
                        elevation="4"
                        absolute
                        right
                    >
                        <v-icon>print</v-icon>
                    </v-btn>
                </v-flex>

                <v-flex xs12>
                    <h3 class="text-center mb-5">Inservice Training Report</h3>
                    <v-divider class="ml-4 mr-4 mb-3"></v-divider>
                </v-flex>

                <v-flex xs12 md6 class="pa-1">
                    <v-menu
                        ref="calendarMenu"
                        v-model="calendarMenu"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="reportFilters.startDate"
                                label="Start Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                :rules='requiredField'
                                clearable
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="reportFilters.startDate"
                            no-title
                            scrollable
                            :rules='requiredField'

                        >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="calendarMenu = false"
                            >
                                Cancel
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="$refs.calendarMenu.save(date)"
                            >
                                OK
                            </v-btn>
                        </v-date-picker>
                    </v-menu>

                </v-flex>

                <v-flex xs12 md6 class="pa-1">
                    <v-menu
                        ref="calendar2Menu"
                        v-model="calendar2Menu"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="reportFilters.endDate"
                                label="End Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                :rules='requiredField'
                                clearable

                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="reportFilters.endDate"
                            no-title
                            scrollable
                            :rules='requiredField'

                        >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="calendar2Menu = false"
                            >
                                Cancel
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="$refs.calendar2Menu.save(date)"
                            >
                                OK
                            </v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-flex>

                <v-flex xs12 md6 class="pa-1 mb-2">
                    <v-select
                        label="Staff Status"
                        :items="staffStatuses"
                        v-model="reportFilters.staffStatus"
                        clearable
                    ></v-select>
                </v-flex>

                <v-flex xs12 md6 class="pa-1 mb-2">
                    <v-select
                        label="Select Staff"
                        :items="filteredEmployees"
                        item-text="Name"
                        item-value="_id"
                        v-model="reportFilters.StaffID"
                        clearable
                    ></v-select>
                </v-flex>

                <v-flex xs12 md4 class="pa-1 mb-2">
                    <v-select
                        label="Status"
                        :items="list"
                        v-model="reportFilters.signatureBool"
                        clearable
                    ></v-select>
                </v-flex>

                <v-flex xs12 md4 class="pa-1 mb-2">
                    <v-select
                        label="Training Subject"
                        :items="trainingSubjectsOptions"
                        v-model="reportFilters.trainingSubject"
                        clearable
                    ></v-select>
                </v-flex>

                <v-flex xs12 md4 class="mt-5 mb-5 pl-5">
                    <v-btn @click="trainingQuery()">Search</v-btn>
                </v-flex>

                <v-flex xs12 class="pa-2">
                    <v-data-table
                        :headers="headers"
                        :items="trainings"
                        sort-by="Date"
                        sort-asc
                        class="elevation-1"
                        :loading="isLoading"
                        loading-text="Loading Inservice Trainings"
                        :items-per-page="100"
                    >
                        <template v-slot:top>
                            <tr>
                                <td></td> <!-- Empty cell for the first column -->
                                <td></td> <!-- Empty cell for the second column -->
                                <td></td> <!-- Empty cell for the third column -->
                                <td></td> <!-- Empty cell for the fourth column -->
                                <td class="text-right pl-3">Total Training Hours:</td>
                                <td class="font-weight-bold pl-2"> {{ calculateTotalHours() }}</td>
                                <!-- Display total hours -->
                                <td></td> <!-- Empty cell for the last column -->
                            </tr>
                        </template>
                        <template v-slot:item.Signed="{ item }">
                            <v-icon
                                class="ma-2"
                                color="red"
                                small
                                v-if="!item.Signed"
                            >
                                close
                            </v-icon>
                            <v-icon
                                class="ma-2"
                                color="green"
                                small
                                v-if="item.Signed"
                            >
                                check
                            </v-icon>
                        </template>
                        <template v-slot:item.select="{ item }">

                            <v-btn
                                x-small
                                class="white--text"
                                color="#2b3990"
                                @click="viewTraining(item)"
                            >
                                View
                            </v-btn>

                        </template>
                    </v-data-table>

                    <v-dialog v-model="dialog" max-width="80%">
                        <v-card>
                            <v-card-title style="background-color: #2b3990">
                                <span class="headline white--text">{{ titleForm }}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" sm="4" v-if="isAdmin">
                                            <v-autocomplete
                                                clearable
                                                :items="users"
                                                item-text="Name"
                                                item-value="_id"
                                                label="Trainer(s)"
                                                multiple
                                                v-model="newTrainer"
                                                prepend-icon="person"
                                            ></v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <v-autocomplete
                                                :items="users"
                                                item-text="Name"
                                                item-value="_id"
                                                label="Trainer(s)"
                                                multiple
                                                v-model="newTrainer"
                                                prepend-icon="person"
                                            ></v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <v-autocomplete
                                                v-model="newTrainingType"
                                                label="Training Type"
                                                :items="Trainings"
                                                item-Name="Name"
                                                :readonly="role != 'Administration'"
                                            ></v-autocomplete>
                                        </v-col>
                                        <!-- <v-col cols="12" sm="4">
                                          <v-autocomplete
                                            v-model="newTrainingSubject"
                                            label="Training Subject"
                                            :items="Subjects"
                                            item-Name="Name"
                                          ></v-autocomplete>
                                        </v-col> -->
                                        <v-col cols="12" sm="4">
                                            <v-text-field
                                                v-model="newTrainingSubject"
                                                label="Training Subject"
                                                :items="Subjects"
                                                item-Name="Name"
                                                :readonly="role != 'Administration'"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <!-- <v-menu
                                              min-width="290px"
                                              max-widht="290px"
                                            >
                                              <template v-slot:activator="{ on }">
                                                <v-text-field
                                                  :value="newDate"
                                                  label="Date of Training"
                                                  v-on="on"
                                                  prepend-icon="events"
                                                  :readonly="role != 'Administration'"

                                                ></v-text-field>
                                              </template>
                                              <v-date-picker v-model="newDate" :readonly="role != 'Administration'"></v-date-picker>
                                            </v-menu> -->
                                            <v-menu
                                                ref="menu"
                                                v-model="menu"
                                                :close-on-content-click="false"
                                                :return-value.sync="date"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="auto"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="newDate"
                                                        label="Date of Training"
                                                        prepend-icon="mdi-calendar"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="newDate"
                                                    no-title
                                                    scrollable
                                                    :readonly="role != 'Administration'"
                                                >
                                                    <v-spacer></v-spacer>
                                                    <v-btn
                                                        text
                                                        color="primary"
                                                        @click="menu = false"
                                                    >
                                                        Cancel
                                                    </v-btn>
                                                    <v-btn
                                                        text
                                                        color="primary"
                                                        @click="$refs.menu.save(date)"
                                                    >
                                                        OK
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="6">

                                            <v-select
                                                :items="times"
                                                v-model="newTimeStarted"
                                                label="Time Training Started"
                                                prepend-icon="mdi-clock-time-four-outline"

                                            ></v-select>

                                        </v-col>

                                        <v-col cols="12" sm="12" md="6">

                                            <v-select
                                                :items="times"
                                                v-model="newTimeEnded"
                                                label="Time Training Ended"
                                                prepend-icon="mdi-clock-time-four-outline"
                                                @change="calcHours()"
                                            ></v-select>

                                        </v-col>
                                        <v-col cols="12" sm="12" md="6">
                                            <v-text-field
                                                v-model="newDuration"
                                                label="Duration"
                                                prepend-icon="schedule"
                                                :readonly="role != 'Administration'"
                                                suffix="hrs"

                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="12">
                                            <v-textarea
                                                v-model="newOutline"
                                                label="Training Outline"
                                                outlined
                                                :readonly="role != 'Administration'"
                                                auto-grow
                                            ></v-textarea>
                                        </v-col>

                                        <v-col cols="12" sm="12">
                                            <v-textarea
                                                v-model="newDescription"
                                                label="Training Description"
                                                outlined
                                                :readonly="role != 'Administration'"
                                                auto-grow
                                            ></v-textarea>
                                        </v-col>

                                        <v-col cols="12" sm="12">
                                            <v-text-field
                                                v-model="newLink"
                                                label="Training Link"
                                                outlined
                                                :readonly="role != 'Administration'"

                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="12">
                                            <v-file-input
                                                v-model="newDocument"
                                                class="pa-2"
                                                label="Select documents to upload"
                                                show-size
                                                filled
                                                multiple
                                                prepend-icon="mdi-camera"
                                                accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                                @change="fileSelected"
                                                :readonly="role != 'Administration'"

                                            >
                                                <template #selection="{ text, index }">
                                                    <v-chip small label close color="primary"
                                                            @click:close="deleteChip(index)">{{ text }}
                                                    </v-chip>
                                                </template>
                                            </v-file-input>
                                        </v-col>

                                        <v-col cols="12" sm="12"
                                               v-for="doc in newDocument"
                                               :key="doc.id"
                                        >
                                            <div v-if="doc.ext !='pdf' ">
                                                <v-img
                                                    max-height="480"
                                                    max-width="550"
                                                    :src="doc.aws"
                                                ></v-img>
                                            </div>
                                            <div v-if="doc.ext =='pdf' ">
                                                <LoadPdf
                                                    :pdfFile="doc.aws"
                                                    :pdfName="doc.name"
                                                />
                                            </div>
                                        </v-col>

                                        <v-col cols="12" sm="6">
                                            <v-checkbox label="Sign for Attending Training" @click="addSignature()"
                                                        v-model="newSigned"></v-checkbox>
                                            <v-expand-transition v-if="newSigned">
                                                <v-text-field label="Signature" v-model="newSignature"
                                                              readonly></v-text-field>
                                            </v-expand-transition>
                                        </v-col>
                                        <v-col cols="12" sm="6" v-if="canSign">
                                            <div class="v-input--selection-controls__ripple primary--text">Trainer Signature</div>
                                            
                                            <v-btn color="#259647" 
                                                class="white--text" 
                                                @click="signAndSave()"
                                                v-if="!newTrainerSigned"
                                                >
                                                    Sign and Save
                                                </v-btn>
                                            <v-expand-transition v-if="newTrainerSigned">
                                            <v-text-field label="Signature" v-model="newTrainerSignature" readonly></v-text-field>
                                            </v-expand-transition>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    fab
                                    small
                                    @click="showPrintModal()"
                                    class="mr-8 mb-2 white--text"
                                    color="#2b6993"
                                    elevation="4"
                                >
                                    <v-icon>print</v-icon>
                                </v-btn>
                                <v-btn color="blue darken-1" text @click="close">Close</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-flex>
            </v-layout>
        </v-card>
        <div id="print">
            <report-header>
                <h2>Inservice Training Report</h2>
            </report-header>
            <v-row>
                <v-col cols="12">
                    <v-data-table
                        :headers="headers"
                        :items="trainings"
                        sort-by="Date"
                        sort-asc
                        class="elevation-1"
                        :loading="isLoading"
                        loading-text="Loading Inservice Trainings"
                        :items-per-page="-1"

                    >
                        <template v-slot:top>
                            <tr>
                                <td colspan="4"></td> <!-- Empty cell for the first column -->
                                <td class="text-right pl-3">Total Training Hours:</td>
                                <td class="font-weight-bold pl-2"> {{ calculateTotalHours() }}</td>
                                <!-- Display total hours -->
                                <td></td> <!-- Empty cell for the last column -->
                            </tr>
                        </template>

                        <template v-slot:item.Signed="{ item }">
                            <v-icon
                                class="ma-2"
                                color="red"
                                small
                                v-if="!item.Signed"
                            >
                                close
                            </v-icon>
                            <v-icon
                                class="ma-2"
                                color="green"
                                small
                                v-if="item.Signed"
                            >
                                check
                            </v-icon>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import {PDFDocument} from "pdf-lib";
import moment from 'moment'
import ReportHeader from '@/components/Report/ReportHeader.vue';
import {
    STATUS_ARRAY,
    STATUSES as UserStatus
} from "../../enums/UserStatusEnum";
import {STATUSES as StaffStatus} from "../../enums/StaffStatusEnum";
import PrintUtil from "../../../utils/print-util";
import ReportFilters from '@/mixins/reportFilters.js';
import {ROLES} from "@/enums/RolesEnum"
// import Foot from '../components/Footer'

const url = require("../../client_config/config").url;

export default {
    mixins: [
        ReportFilters,
    ],
    components: {
        ReportHeader
    },
    data: () => ({
        headers: [
            {
                text: 'Date',
                align: 'start',
                sortable: true,
                value: 'Date',
            },
            {text: "Duration", value: "Duration"},
            {text: "Employee", value: "EmployeeID.Name"},
            {text: "Training Type", value: "TrainingType"},
            {text: "Training Subject", value: "TrainingSubject"},
            {text: "Trainers", value: "Trainers"},
            {text: "Signed", value: "Signed"},
            {text: "", value: "select"},

        ],
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        employees: [],
        trainings: [],
        dialog: false,
        calendarMenu: false,
        calendar2Menu: false,
        menu: false,
        menu2: false,
        report: '',
        staff: '',
        clientName: '',
        isLoading: false,
        signed: false,
        role: localStorage.getItem('userRole'),
        state: localStorage.getItem('userState'),
        requiredField: [
            v => !!v || 'This is required',
        ],
        Trainings: ["Corporate Training (All Employees)", "Manager Training (All Managers)",
            "Asst Manager Training", "House Training", "Staff Training", "Adjustment Training"],
        Subjects: ["January Staff AT: Abuse, Neglect and Exploitation (Full Course) Client MR: The right to be treated with dignity and respect, the right to be free from abuse, neglect, and exploitation.",
            "February Staff AT: Medical Supports, Identifying & Managing Medical Emergencies 1. Identifying 2. Managing Client MR: The right to live in the least restrictive environment possible and to move freely in my environment, the right to have reasonable access to telephones and a reasonable amount of privacy.",
            "March Staff AT: Medication Supports Client MR: The right to have a private place to have visitors, the right to have writing materials, envelopes, and postage, the right to send and receive unopened mail.",
            "April Staff AT: Infection Control & Standard Precautions 1. Safe Food Handling Client MR: The right to have and keep personal possessions, the right to manage my own money and have access to financial records.",
            "May Staff AT: Documentation & Billing Requirements 1. Residential Service Log 2. Ancillary and Case Management Client MR: The right to make decisions about personal goals, the right to go to school and/or work and get paid for the work I do.",
            "June Staff AT: Abuse, Neglect and Exploitation (Abbreviated) Client MR: The right to vote, the right to participate in religious training or attend church.",
            "July Staff AT: Incident Reporting 1. The How’s 2. The When’s 3. The Why’s Client MR: The Right to Freedom of Speech, the Right to have Friends & Close Relationships",
            "August Staff AT: Personal Rights/Responsibilities, Dignity and Respect, and Due Process with the HRC 1. Dignity and Respect 2. Due Process 3. HRC/BIC Client MR: The right to have assistance from my guardian if I need it, the right to have representation and/or advocacy.",
            "September Staff AT: Disaster and Emergency Preparedness Client MR: The right to be fully informed orally and in writing of my rights and responsibilities, the right to informed consent before treatment begins.",
            "October Staff AT: HIPAA & Confidentiality Client MR: The right to prompt and appropriate treatment in a manner consistent with current standards of practice that includes prevention of illness or disability, the right to appeal decisions as they relate to my plan.",
            "November Staff AT: Ethics, Boundaries and Professional Behaviors Client MR: The right to look at my clinical record, the right to have personal information shared only with my permission.",
            "December Staff AT: Positive Behavior Approaches and Supports Client MR: The right to refuse or select to be photographed and/or participate in research, the right to be informed of reasons for voluntary or mandatory transfer, admission, discharge, or commitment.",
            "ANE Specific Training",
            "Client Specific Training",
            "Clinical Disorders Charting",
            "Code of Conduct",
            "Ethics",
            "Hippa Specific Training",
            "House Meetings",
            "Managing Aggressive De-escalation",
            "Medication administration procedures",
            "Monthly Rights and CE Staff Training",
            "Personality Behavior",
            "Other",
        ],
        titleForm: "New Training",
        trainingID: "",
        token: localStorage.getItem('token'),
        newTrainer: [],
        newTrainingType: "",
        newTrainingSubject: "",
        newDate: moment(new Date()).format("YYYY-MM-DD"),
        newTimeStarted: "",
        newTimeEnded: "",
        newDuration: "",
        newOutline: "",
        newDescription: "",
        newSigned: false,
        newSignature: "",
        newLink: "",
        editedIndex: -1,
        documents: "",
        documentLink: "",
        newDocument: [],
        imageDetails: [],
        pdfDetails: [],
        notSigned: false,
        employee: {},
        uploadFile: "",
        times: [
            "6:00AM", "6:15AM", "6:30AM", "6:45AM",
            "7:00AM", "7:15AM", "7:30AM", "7:45AM",
            "8:00AM", "8:15AM", "8:30AM", "8:45AM",
            "9:00AM", "9:15AM", "9:30AM", "9:45AM",
            "10:00AM", "10:15AM", "10:30AM", "10:45AM",
            "11:00AM", "11:15AM", "11:30AM", "11:45AM",
            "12:00PM", "12:15PM", "12:30PM", "12:45PM",
            "1:00PM", "1:15PM", "1:30PM", "1:45PM",
            "2:00PM", "2:15PM", "2:30PM", "2:45PM",
            "3:00PM", "3:15PM", "3:30PM", "3:45PM",
            "4:00PM", "4:15PM", "4:30PM", "4:45PM",
            "5:00PM", "5:15PM", "5:30PM", "5:45PM",
            "6:00PM", "6:15PM", "6:30PM", "6:45PM",
            "7:00PM", "7:15PM", "7:30PM", "7:45PM",
            "8:00PM", "8:15PM", "8:30PM", "8:45PM",
            "9:00PM", "9:15PM", "9:30PM", "9:45PM",
            "10:00PM", "10:15PM", "10:30PM", "10:45PM",
            "11:00PM", "11:15PM", "11:30PM", "11:45PM",
        ],
        list: [
            "Signed",
            "Needs Signature"
        ],
        text: "",
        msg: false,
        isAdmin: false,
        users: [],
        staffStatuses: STATUS_ARRAY,
        trainingSubjectsOptions: [],
        reportFilters:  {
            startDate: '',
            endDate: '',
            staffStatus: '',
            StaffID: '',
            signatureBool: '',
            trainingSubject: '',
        },
        reportFilterName: 'ReportFilters_InserviceTrainingReport',
        newTrainerSigned: false,
        newTrainerSignature: "",
        userRole: localStorage.getItem('userRole')
    }),

    computed: {
        filteredEmployees() {
            const employees = this.users;
            const staffStatus = this.reportFilters.staffStatus;

            if (staffStatus === UserStatus.INACTIVE) {
                return employees.filter(
                    (employee) => employee.Status === StaffStatus.TERMINATED
                );
            }

          if (staffStatus === UserStatus.ACTIVE) {
            return employees.filter(
              (employee) =>
                employee.Status === StaffStatus.FULL_TIME ||
                employee.Status === StaffStatus.PART_TIME ||
                employee.Status === "" ||
                employee.Status === null
            );
          }

            return employees;
        },
        canSign() {
            const allowedRoles = [
                ROLES.SUPER_ADMINISTRATOR,
                ROLES.ADMINISTRATION,
                ROLES.HOUSE_MANAGER
            ];
            return allowedRoles.includes(this.userRole);
        }

    },

    created() {
        this.getEmployees();
        this.getTrianingSubjects();
        this.reportFilters = this.getReportFilters(this.reportFilterName) ?? this.reportFilters;
    },

    mounted() {
        window.addEventListener('keydown', async (event) => {
            const downloadUrl = await this.generateDownloadUrl();
            PrintUtil.handleKeydown(event, downloadUrl, this.trainingID, this.token, 'Training');
        });
    },

    beforeDestroy() {
        window.removeEventListener('keydown', (event) => {
            PrintUtil.handleKeydown(event, this.downloadUrl, this.trainingID, this.token, 'Training');
        });
    },

    watch: {
    reportFilters: {
        handler(newVal) {
        this.setReportFilters(this.reportFilterName, newVal);
        },
        deep: true
    }
    },

    methods: {
        initialize() {
            this.trainings = [];
        },

        // Method to calculate the total hours
        calculateTotalHours() {
            let totalHours = 0;
            for (const training of this.trainings) {
                const duration = parseFloat(training.Duration);
                totalHours += isNaN(duration) ? 0 : duration;
            }
            return totalHours.toFixed(2); // You can adjust the number of decimal places as needed
        },

        async getEmployees() {
            let endpoint = '';
            const companyIds = localStorage.getItem('userCompanies');

            endpoint = `${url}/users/state/${this.state}`;

            await axios.get(endpoint, {
                params: {
                    Company: JSON.parse(companyIds)
                }
            }).then(res => {
                this.users = res.data.users;

            });
        },
        close() {
            this.dialog = false;
        },

        async generateDownloadUrl() {
            return `${url}/inserviceTraining/print-pdf?id=${this.trainingID}`;
        },

        async showPrintModal() {
            const downloadUrl = await this.generateDownloadUrl();
            PrintUtil.showPrintOption(downloadUrl, this.trainingID, this.token, 'InServiceTraining');
        },

        trainingQuery() {
            this.trainings = []
            this.isLoading = true;

            const companyIds = localStorage.getItem('userCompanies');

            axios.get(`${url}/inserviceTraining/report/query`, {
                params: {
                    startDate: this.reportFilters.startDate,
                    endDate: this.reportFilters.endDate,
                    staffID: this.reportFilters.StaffID,
                    state: this.state,
                    signatureBool: this.reportFilters.signatureBool,
                    Company: JSON.parse(companyIds),
                    staffStatus: this.reportFilters.staffStatus,
                    trainingSubject: this.reportFilters.trainingSubject
                }
            }).then(res => {
                this.trainings = res.data.trainings.map(training => {
                    return {
                        ...training,
                        Trainers: training.Trainers.map(trainer => trainer.Name).join(', ')
                    };
                });
                this.isLoading = false;
            })

        },

        getStaffID(item) {
            this.staff = item.EmployeeID;
            window.localStorage.setItem('staffId', this.staff)
            console.log(this.staff + " is the staff")
        },

        viewTraining(item) {
            if (item.Signature == null) {
                this.newSigned = false
            } else {
                this.newSigned = true
            }
            this.titleForm = "Viewing Training";
            this.dialog = true;
            this.editTraining = true;
            this.newTraining = false;
            this.newTrainingType = item.TrainingType;
            this.newTrainingSubject = item.TrainingSubject;
            this.newDate = item.Date;
            this.newTimeStarted = item.TimeStarted;
            this.newTimeEnded = item.TimeEnded;
            this.newDuration = item.Duration;
            this.newOutline = item.Outline;
            this.newDescription = item.Description;
            this.newSigned = item.Signed;
            this.newSignature = item.Signature;
            this.newTrainer = item.Trainer;
            this.newLink = item.Link;
            this.trainingID = item._id;
            this.newTrainerSignature = item.TrainerSignature == undefined ? '':item.TrainerSignature;
            this.newTrainerSigned = this.newTrainerSignature == '' ? false : true;
            if (item.documents.length > 0) {
                const tempData = [];
                for (let i = 0; i < item.documents.length; i++) {
                    let fileExt = item.documents[i].AWSLink.split('.').pop();
                    tempData.push({
                        name: item.documents[i].Name,
                        id: item.documents[i]._id,
                        aws: item.documents[i].AWSLink,
                        ext: fileExt

                    });
                }
                this.newDocument = tempData;
            }
        },

        async fileSelected(e) {
            this.uploadFile = await this.renameFileHelper(e, this.staffName, "InserviceTraining", this.newDate);
        },

        saveFile() {
            this.message = "";
            for (let i = 0; i < this.uploadFile.length; i++) {
                this.uploadFiles(this.uploadFile[i]);
            }
        },

        uploadFiles(file) {
            const formData = new FormData();
            formData.append('inserviceTraining', file);
            var ct = {headers: {"content-type": "multipart/form-data"}};
            axios.post(`${url}/inserviceTraining/fileuploader/${this.trainingID}/${this.employeeID}`, formData, ct)
                .then(res => {
                    if (res) {
                        this.getTrainings();
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },

        deleteChip(index) {
            // Prompt here with text if required
            this.newDocument.splice(index, 1);
        },

        async loadPdf(url) {

            let fetching = [];
            for (let i = 0; i < url.length; i++) {
                const existingPdfBytes = await fetch(url[i]).then((res) => res.arrayBuffer());
                fetching.push(existingPdfBytes);
            }

            let load = [];
            for (let i = 0; i < fetching.length; i++) {
                const pdfDoc = await PDFDocument.load(fetching[i]);
                load.push(pdfDoc);
            }

            const pdfDocCreate = await PDFDocument.create();
            let copy = [];
            for (let i = 0; i < load.length; i++) {
                const [firstDonorPage] = await pdfDocCreate.copyPages(load[i], [0]);
                copy.push(firstDonorPage);
            }

            let counter = 0;
            for (let i = 0; i < copy.length; i++) {
                if (i == 0) {
                    pdfDocCreate.addPage(copy[i]);
                } else {
                    pdfDocCreate.insertPage(counter, copy[i]);
                    counter++;
                }
            }

            const fDataUri = await pdfDocCreate.saveAsBase64({dataUri: true});
            document.getElementById('pdf').src = fDataUri;

        },

        printTable() {
            window.print()
        },

        async getTrianingSubjects(){
            const endpoint = `${url}/inserviceTraining/trainingSubjects`;

            await axios.get(endpoint).then(res => {
                this.trainingSubjectsOptions = res.data;
            });
        },
        signAndSave() {
            this.newTrainerSigned = true;
            let req_body = {
                TrainerSignature: this.newTrainerSignature,
            }
            axios.put(`${url}/inserviceTraining/${this.trainingID}`, req_body)
            .then((response) => {
                if (response.status == 400) {
                response.json().then(function(data) {
                    alert(data.msg);
                });
                }
                this.msg =true;
                this.text ="The training has been updated successfully.";

            });
        }
    }
}
</script>
<style>
#print {
    display: none
}

@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}


@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}

@media print {
    #print {
        display: block;
        border: none;
        width: 1200px;
        padding-right: 300px;
        margin-left: -200px;

    }


    nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
        display: none;
        border: none;

    }

    @page {
        margin: 0;
    }

    body {
        margin: 1.6cm;
    }


}
</style>
